<template>
    <div
        :style="{ maxWidth: `${maxWidth}px` }"
        class="text-white text-5xl mt-20 h-20"
    >
        <div class="conferenceRoomNameContainer text-center">
            <div
                class="itemName"
                :class="{ conferenceRoomName: hasOverflow }"
            >
                {{ roomName }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RoomNameDisplay",

    props: {
        roomName: {
            type: String,
            required: true,
        },
        maxWidth: {
            type: Number,
            required: true,
        },
    },

    data: () => ({
        hasOverflow: false,
        textWidth: 0,
        containerWidth: 0,
    }),

    watch: {
        roomName() {
            this.$nextTick(() => {
                this.checkOverflow();
            });
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.checkOverflow();
        });
    },

    methods: {
        getTextWidth() {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            ctx.font = "3rem Montserrat";
            const measurement = ctx.measureText(this.roomName);
            return measurement.width;
        },

        checkOverflow() {
            const marqueeText = this.$el.querySelector(".itemName");
            const marqueeContainer = this.$el.querySelector(".conferenceRoomNameContainer");

            if (marqueeText && marqueeContainer) {
                this.textWidth = this.getTextWidth();
                this.containerWidth = marqueeContainer.offsetWidth;
                this.hasOverflow = this.textWidth > this.containerWidth;
            }
        },
    },
};
</script>

<style scoped>
/* Text Colors */
.text-white {
    color: #ffffff;
}

/* Text Size */
.text-5xl {
    font-size: 3rem;
    line-height: 1;
}

/* Text Alignment */
.text-center {
    text-align: center;
}

/* Spacing */
.mt-20 {
    margin-top: 5rem;
}
.h-20 {
    height: 5rem;
}

/* Container styling */
.conferenceRoomNameContainer {
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    height: 60px;
}

.conferenceRoomName {
    display: inline-block;
    white-space: nowrap;
    -webkit-animation: conferenceRoomNameFlow 10s linear infinite;
    animation: conferenceRoomNameFlow 10s linear infinite;
    font-size: 3rem;
    color: white;
}

@-webkit-keyframes conferenceRoomNameFlow {
    0% {
        -webkit-transform: translateX(90%);
        transform: translateX(90%);
    }
    100% {
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
    }
}

@keyframes conferenceRoomNameFlow {
    0% {
        -webkit-transform: translateX(90%);
        transform: translateX(90%);
    }
    100% {
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
    }
}

/* montserrat-regular - latin */
@font-face {
    font-display: swap;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    src: url("/fonts/montserrat-v25-latin-regular.eot");
    src: url("/fonts/montserrat-v25-latin-regular.eot?#iefix") format("embedded-opentype"),
        url("/fonts/montserrat-v25-latin-regular.woff2") format("woff2"),
        url("/fonts/montserrat-v25-latin-regular.woff") format("woff"),
        url("/fonts/montserrat-v25-latin-regular.ttf") format("truetype"),
        url("/fonts/montserrat-v25-latin-regular.svg#Montserrat") format("svg");
}
</style>
